.strip { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px 24px; padding: 16px 24px; background: var(--paper); border: var(--border-panel); box-shadow: var(--shadow-panel); }
.left { display: flex; flex-direction: column; gap: 10px; min-width: 0; }
.right { display: flex; align-items: center; gap: 20px; }
.eyebrow { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--ink); }
.date { color: var(--text-secondary); }
.badge { display: inline-flex; align-items: center; gap: 6px; padding: 2px 8px; background: var(--paper-2); border: var(--border-hair); color: var(--ink); }
.dot { width: 7px; height: 7px; background: var(--green); }
.block { display: flex; align-items: center; gap: 14px; min-width: 0; }
.duration { font-family: var(--font-cond); font-size: 26px; font-weight: 900; letter-spacing: -0.5px; line-height: 1; color: var(--ink); white-space: nowrap; }
.defaulted { font-family: var(--font-mono); font-size: 9px; font-weight: 400; letter-spacing: 1.2px; color: var(--text-secondary); }
.rule { flex: none; width: 1px; height: 20px; background: var(--line); }
.tallRule { flex: none; width: 1px; height: 28px; background: var(--line); }
.plannedQuiet + .tallRule { height: 36px; }
.note { margin: 0; font-size: 14px; color: var(--ink); }
.label { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); }
.next { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; }
.nextText { font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.8px; color: var(--ink); }
.nextLine { margin: 0; font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.8px; color: var(--text-secondary); }
.estimate { display: flex; align-items: baseline; gap: 6px; margin: 0; }
.figure { font-family: var(--font-cond); font-size: 26px; font-weight: 900; letter-spacing: -0.5px; line-height: 1; color: var(--ink); }
.unit { font-family: var(--font-mono); font-size: 11px; letter-spacing: 0.6px; color: var(--text-secondary); }
.estimate[data-quiet='true'] .figure { color: var(--text-secondary); }
.plannedQuiet, .ridden { display: flex; flex-direction: column; gap: 4px; }
.plannedQuiet .figure, .ridden .figure { font-size: 20px; }
.ridden .label { color: var(--ink); }
.riddenValues { display: flex; align-items: baseline; gap: 6px; margin: 0; }
.riddenValues .unit + .sep { margin-left: 8px; }
.sep { display: none; }
.calendarLink, .notToday { display: inline-flex; align-items: center; padding: 9px 14px; background: var(--paper); border: var(--border-control); font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--ink); white-space: nowrap; }
.planWeek, .add { display: inline-flex; align-items: center; padding: 9px 14px; background: var(--pink); border: var(--border-control); font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--ink); white-space: nowrap; }
.add:disabled { opacity: 0.5; cursor: progress; }
.suggestedBadge { padding: 2px 8px; border: 1px dashed var(--ink); color: var(--ink); }
.duration[data-quiet='true'] { color: var(--text-secondary); }
.duration:empty, .structure:empty { display: none; }
.structure { margin: 0; font-size: 14px; color: var(--ink); }
.why { margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); }
.actions { display: flex; align-items: center; gap: 10px; }
/* The swap strip and a save error take a row of their own under the block. */
.strip > [role='group'], .strip > [role='alert'] { flex-basis: 100%; }
.nothing { display: flex; flex-wrap: wrap; align-items: baseline; gap: 14px; margin: 0; font-size: 16px; color: var(--ink); }
.spacer { flex: 1; }

@media (max-width: 639px) {
  .strip { flex-direction: column; flex-wrap: nowrap; align-items: stretch; gap: 10px; padding: 12px 14px; box-shadow: 4px 4px 0 var(--ink); }
  .top { display: flex; align-items: center; justify-content: space-between; gap: 8px; min-height: 28px; }
  /* A 44px hit area without growing the 28px row. */
  .calendarLink { min-height: 44px; margin: -8px 0; padding: 0; background: none; border: 0; }
  .block { gap: 12px; }
  .duration, .figure { font-size: 24px; }
  .note { font-size: 13px; }
  .ridden { flex-direction: row; align-items: center; justify-content: space-between; padding: 8px 10px; background: var(--paper-2); }
  .ridden .figure { font-size: 18px; }
  .riddenValues { gap: 8px; }
  .unit[data-part='time'] { display: none; }
  .sep { display: inline; font-family: var(--font-mono); font-size: 10px; color: var(--text-secondary); }
  .riddenValues .unit + .sep { margin-left: 0; }
  .nextLine { font-size: 9px; }
  .nothing .label { display: none; }
  .planWeek, .add { justify-content: center; height: 44px; padding: 0 16px; }
  .actions > button { flex: 1; justify-content: center; height: 44px; }
  .structure { font-size: 13px; }
}
